import { RouteModule } from '#/horizon/components/RouteModule';
import { MovementPageLoadable } from '#/pages/movement/MovementPageLoadable';

export default function MovementHorizonRoute() {
  return (
    <RouteModule title="Interest Form">
      <MovementPageLoadable />
    </RouteModule>
  );
}
